/** 工作台 */
export default {
    dataOverview: "ภาพรวมข้อมูล", // 数据总览
    queryBasicData: "ค้นหาข้อมูลพื้นฐาน", // 查询基础数据
    dataQuery: "ค้นหาข้อมูล", // 数据查询
    dataOutput: "ส่งออกข้อมูล", // 数据导出
    dataImportAndExport: "การนำเข้าและส่งออกข้อมูลการไหลผู้โดยสาร", // 客流数据导入与导出
    entranceAndExitDataQuery: "ค้นหาข้อมูลการไหลผู้โดยสารทางเข้าและทางออก", // 出入口客流数据查询
    dataCorrection: "การแก้ไขข้อมูล", // 数据修正
    customerPortrait: "ภาพเสมือนลูกค้า", // 客户画像
    // การแยกแยะเพศชายและหญิงและการวิเคราะห์อายุของลูกค้าด้วยการรู้จักใบหน้า
    faceRecognitionOfMenAndWomen: "การรู้จักใบหน้าชายและหญิงและการวิเคราะห์อายุของลูกค้า",
    operationGuide: "คู่มือการใช้งาน", // 操作指南
    systemOperationFlowchart: "แผนภาพขั้นตอนการทำงานของระบบ", // 系统操作流程图
    afterSalesService: "บริการหลังการขาย", // 售后服务
    AfterSalesQA: "คำถามที่พบบ่อยเกี่ยวกับหลังการขาย", // 售后答疑解惑
    operationSystemHeadquartersBranches: "ระบบการทำงานของสำนักงานใหญ่และสาขา", // 总分馆运营系统
    libraryCustomDataLargeScreenCase: "กรณีหน้าจอข้อมูลที่ปรับแต่งสำหรับห้องสมุด", // 图书馆定制数据大屏案例
    passengerFlowSystemHeadquartersBranches: "ระบบการไหลผู้โดยสารสำหรับสำนักงานใหญ่และสาขา", // 总分馆客流系统
    generalCustomDataLargeScreenCase: "กรณีหน้าจอข้อมูลที่ปรับแต่งสำหรับทั่วไป", // 通用定制数据大屏案例
    realTimePassengerFlowScreen: "หน้าจอแสดงผลการไหลผู้โดยสารแบบเรียลไทม์", // 实时客流大屏
    realTimePassengerFlowScreenSubTitle: "กรณีหน้าจอข้อมูลแบบเรียลไทม์ที่ไดนามิก", // 实时动态数据大屏案例
    simpleCarryingCapacityScreen: "ข้อมูลการรับภาระที่ง่าย", // 简单承载量数据大屏
    simpleCarryingCapacityScreenSubTitle: "กรณีศึกษาข้อมูลที่ปรับแต่งสำหรับความจุของพื้นที่ท่องเที่ยว", // 景区承载量定制数据大屏案例
    VRTemplateDataScreen: "หน้าจอข้อมูลแม่แบบ VR", // VR模板数据大屏
    VRTemplateDataScreenSubTitle: "กรณีหน้าจอข้อมูลที่ปรับแต่งสำหรับห้องแสดง VR", // VR展馆定制数据大屏案例
    // ---------------------------------------------------------------- ส่วนภายในหน้า
    passengerFlowAnalysis: "การวิเคราะห์การไหลผู้โดยสาร", // 客流分析
    passengerFlowPerson: "การไหลผู้โดยสาร (คน)", // 客流(人)
    time: "เวลา", // 时间
    entityOverview: "ภาพรวมของร้าน", // 实体概览
    toDayPassengerFlow: "การไหลผู้โดยสารวันนี้", // 今日客流
    yesterdayPassengerFlow: "การไหลผู้โดยสารเมื่อวาน", // 昨日客流
    sametimeLastWeek: "ช่วงเวลาเดียวกันในสัปดาห์ที่ผ่านมา", // 上周同期
    growthAmplitude: "อัตราการเติบโต", // 增长幅
    passengerFlowThisWeek: "การไหลผู้โดยสารในสัปดาห์นี้", // 本周客流
    passengerFlowLastWeek: "การไหลของผู้โดยสารสัปดาห์ที่ผ่านมา", // 上周客流
    passengerFlowThisMonth: "การไหลผู้โดยสารในเดือนนี้", // 本月客流
    passengerFlowThisYear: "การไหลผู้โดยสารในปีนี้", // 本年客流
    lastMonth: "การไหลผู้โดยสารเดือนที่แล้ว", // 上月客流
    date: "วันที่", // 日期
    entityPassengerFlow: "การไหลผู้โดยสารของธุรกิจ (สำหรับการค้นหาเพียง 30 อันดับแรก)", // 图标分析(最多查询前20条)
    detailList: "รายการรายละเอียด", // 详情列表
    queryCondition: "เงื่อนไขการค้นหา", // 查询条件
    target: "เป้าหมาย", // 指标
    entryNumber: "จำนวนคนที่เข้า", // 进人数 walk into
    exitNumber: "จำนวนคนที่ออก", // 出人数 walk out
    passingsNumber: "จำนวนคนที่ผ่าน ", // 经过人数 walk pass
    strand: "จำนวนคนที่ตกอยู่ ", // 滞留人数
    groupType: "ประเภทการสรุป", // 汇总类型
    entityGroup: "รวมตามร้าน", // 按实体汇总
    organizationGroup: "รวมตามโครงสร้างองค์กร", // 按组织架构汇总
    fiveMinute: "5 นาที", // 五分钟
    halfHour: "ครึ่งชั่วโมง", // 半小时
    hour: "ชั่วโมง", // 小时
    day: "วัน", // 天
    week: "สัปดาห์", // 周
    month: "เดือน", // 月
    year: "ปี", // 年
    dimension: "มิติ", // 维度
    temporalInterval: "ช่วงเวลา", // 时间区间
}
